module.exports = __webpack_public_path__ + "img/mono-square.f5fbcbbc.svg";